const Title = ({ width, type, children }) => {
    return (
        <h4
            className={` mx-10 p-4 ${width === "fit" && "w-fit"} font-bold border-b-2 ${
                type === "light" ? "text-slate-50 border-slate-50" : "text-sky-900  border-sky-900"
            }`}
        >
            {children}
        </h4>
    );
};

export default Title;
